import React from "react";
import { Calendar } from "react-big-calendar";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";

const DnDCalendar = withDragAndDrop(Calendar);

const CalendarHoc = ({ isDnd, onEventDrop, onEventResize, ...props }) => {
  // If isDnd is true, return DnD Calendar with drag/drop handlers
  if (isDnd) {
    return (
      <DnDCalendar
        {...props}
        onEventDrop={onEventDrop}
        onEventResize={onEventResize}
        resizable
        draggableAccessor={() => true}
      />
    );
  }

  // Otherwise return normal Calendar
  return <Calendar {...props} />;
};

export default CalendarHoc;
